export const AVAILABLE_PAYMENT_SYSTEMS = ['PayPal', 'Stripe', 'Pay on arrival'];
export const DELETE_PAYMENT_INFO = 'DELETE_PAYMENT_INFO';
export const DELETE_INTEGRATION_SETTINGS = 'DELETE_INTEGRATION_SETTINGS';
export const RESET_DELETED_INTEGRATION_SETTINGS =
  'RESET_DELETED_INTEGRATION_SETTINGS';
export const DELETE_TREKKSOFT_CATEGORIES = 'DELETE_TREKKSOFT_CATEGORIES';
export const PAY_ON_ARRIVAL = 'Pay on arrival';
export const PAY_PAL_SYSTEM = 'PayPal';
export const STRIPE_SYSTEM = 'Stripe';
export const TREKKSOFT = 'Trekksoft';
export const EXPEDIA = 'Expedia';
export const BOOKING = 'BOOKING';
